import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TConnector } from "@answerr/types";

interface ConnectorsState {
  connectorsList: TConnector[];
}

const initialState: ConnectorsState = {
  connectorsList: [],
};


const connectorsSlice = createSlice({
  name: 'connectors',
  initialState,
  reducers: {
    setConnectorsList: (state, action: PayloadAction<TConnector[]>) => {
      state.connectorsList = action.payload;
    },
    addConnector: (state, action: PayloadAction<TConnector>) => {
      state.connectorsList.push(action.payload);
    },
    updateConnector: (state, action: PayloadAction<TConnector>) => {
      const index = state.connectorsList.findIndex((connector) => connector.slug === action.payload.slug);
      if (index !== -1) {
        state.connectorsList[index] = action.payload;
      }
    },
    deleteConnector: (state, action: PayloadAction<string>) => {
      state.connectorsList = state.connectorsList.filter((connector) => connector.slug !== action.payload);
    },
  },
});

export const { setConnectorsList, addConnector, updateConnector, deleteConnector } = connectorsSlice.actions;

export default connectorsSlice.reducer;